import { Dispatch, SetStateAction, createContext } from 'react';
import { noop } from 'lodash';

interface DismissConfirmContextValue {
	setDismissModalVisible: Dispatch<SetStateAction<boolean>>;
	setIdsToDismiss: Dispatch<SetStateAction<string[]>>;
}

const defaultValue: DismissConfirmContextValue = {
	setDismissModalVisible: noop,
	setIdsToDismiss: noop
};

const DismissConfirmContext = createContext<DismissConfirmContextValue>(defaultValue);

export default DismissConfirmContext;
